<div class="card-header px-3 py-1 pointer text-bg-warning" (click)="panelOpen=!panelOpen">
  {{title}} 
  <div class="float-end collapse-button" [ngClass]="{'is-collapsed': !panelOpen}"><i class="fas fa-chevron-up"></i></div>
  <button class="btn btn-xs btn-warning float-end mx-3" (click)="mainService.saveToClipBoard(json, $event)"><i class="far fa-copy"></i></button>
</div>
<div *ngIf="panelOpen" [@slideInOut] class="card-body collapsable pb-3">
  <ngx-json-viewer [json]="object" [expanded]="true"></ngx-json-viewer>
</div>
